import { Injectable } from '@angular/core';
import { DynamicScript } from '../classes/dynamicScripts';
import { DomManipulationService } from './dom-manipulation/dom-manipulation.service';


/**
 * A service that injects a script to load webfonts in the front-end.
 */
@Injectable()
export class WebfontLoaderService {

  constructor(
      private domManipulationService: DomManipulationService,
  ) { }

  injectWebfontScript(): void {
    this.domManipulationService.loadScript(this.getWebfontScript());
  }

  private getWebfontScript(): DynamicScript {
    return {
      id: 'webfontScript',
      inlineContent: `
        <!-- Preload webfonts asynchronously -->
        WebFontConfig = {
            google: {
                families: ['Material Icons', 'Roboto:300,400,500', 'Montserrat:300,500,600&display=swap']
            },
            timeout: 20000
        };

        (function(d) {
            var wf = d.createElement('script'), s = d.scripts[0];
            wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
            wf.async = true;
            s.parentNode.insertBefore(wf, s);
        })(document);
      `,
      async: true
    }
  }
}
